import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@core/authentication';
import { LocalizationService } from '@core/services/localization';

export const publicPagesGuard: CanActivateFn = () => {
    const authenticationService = inject(AuthenticationService);
    const localizationService = inject(LocalizationService);

    localizationService.initPublicPagesLanguage();

    return authenticationService.setIsActiveAccountValid();
};
